(function () {
  const root = window.EFFitmentSearch || {};
  const config = root.config || {};
  const cache = { manifest: null, indexes: new Map() };
  const PAGE_SIZE = 24;

  // EF SEARCH FIX 2026-08-01 START (Farbwoerterbuch DE/EN - kompletten Block loeschen = Rueckbau)
  const EF_COLOR_GROUPS = [
    ['blau', 'blue'],
    ['schwarz', 'black'],
    ['weiss', 'weiß', 'white'],
    ['rot', 'red'],
    ['gruen', 'grün', 'green'],
    ['gelb', 'yellow'],
    ['orange'],
    ['grau', 'gray', 'grey'],
    ['silber', 'silver'],
    ['gold'],
    ['rosa', 'pink'],
    ['lila', 'violett', 'purple'],
    ['tuerkis', 'türkis', 'turquoise'],
    ['matt', 'matte'],
    ['glaenzend', 'glänzend', 'gloss', 'glossy'],
    ['carbon'],
    ['chrom', 'chrome'],
    ['bronze'],
    ['kupfer', 'copper'],
    ['beige'],
    ['braun', 'brown']
  ];
  const EF_COLOR_SYNONYMS = (function () {
    const map = {};
    EF_COLOR_GROUPS.forEach(function (group) {
      const keys = Array.from(new Set(group.map(matchKey).filter(Boolean)));
      keys.forEach(function (key) {
        const others = keys.filter(function (other) { return other !== key; });
        map[key] = Array.from(new Set((map[key] || []).concat(others)));
      });
    });
    return map;
  })();
  // EF SEARCH FIX 2026-08-01 END
  const I18N = {
    en: {
      availability: 'Availability',
      brand: 'Brand',
      model: 'Model',
      year: 'Year',
      type: 'Type',
      price: 'Price',
      min: 'Min',
      max: 'Max',
      activeFilters: 'Active filters',
      remove: 'Remove',
      clearAll: 'Clear all',
      filters: 'Filters',
      activeFiltersCount: 'active filters',
      viewGridMode: 'View grid mode',
      viewListMode: 'View list mode',
      sortOptions: 'Sort options',
      products: 'Products',
      viewProductsTab: 'View Products Tab',
      relevance: 'Relevance',
      titleAsc: 'Title: A-Z',
      titleDesc: 'Title: Z-A',
      dateDesc: 'Date: New to Old',
      dateAsc: 'Date: Old to New',
      priceAsc: 'Price: Low to High',
      priceDesc: 'Price: High to Low',
      bestselling: 'Bestselling',
      priceCurrency: 'Price, €',
      minValue: 'Minimum value',
      maxValue: 'Maximum value',
      noCompatible: 'No compatible products found',
      noCompatibleFor: 'No compatible products found for',
      euStock: 'EU Stock',
      precisionBuild: 'Precision Build',
      inStockPrice: 'In-stock price',
      customBuiltPrice: 'Custom-built price',
      storeRatingAria: 'EuroFairings store rating: 4.7 out of 5',
      storeRating: 'EuroFairings 4.7/5',
      viewProduct: 'View product',
      verifiedFitment: 'Verified Fitment',
      support: 'DE/EN Support',
      productType: 'Product type',
      showingResults: 'Showing <b>{count}</b> results for "{query}"',
      searchTitle: 'Search: {count} results found for "{query}" - EuroFairings',
      closeFilters: 'Close filters',
      close: 'Close'
    },
    de: {
      availability: 'Verfügbarkeit',
      brand: 'Marke',
      model: 'Modell',
      year: 'Baujahr',
      type: 'Typ',
      price: 'Preis',
      min: 'Min.',
      max: 'Max.',
      activeFilters: 'Aktive Filter',
      remove: 'Entfernen',
      clearAll: 'Alles löschen',
      filters: 'Filter',
      activeFiltersCount: 'aktive Filter',
      viewGridMode: 'Rasteransicht',
      viewListMode: 'Listenansicht',
      sortOptions: 'Sortieroptionen',
      products: 'Produkte',
      viewProductsTab: 'Produkte anzeigen',
      relevance: 'Relevanz',
      titleAsc: 'Titel: A-Z',
      titleDesc: 'Titel: Z-A',
      dateDesc: 'Datum: neu zu alt',
      dateAsc: 'Datum: alt zu neu',
      priceAsc: 'Preis: niedrig zu hoch',
      priceDesc: 'Preis: hoch zu niedrig',
      bestselling: 'Bestseller',
      priceCurrency: 'Preis, €',
      minValue: 'Mindestwert',
      maxValue: 'Höchstwert',
      noCompatible: 'Keine kompatiblen Produkte gefunden',
      noCompatibleFor: 'Keine kompatiblen Produkte gefunden für',
      euStock: 'EU Stock',
      precisionBuild: 'Precision Build',
      inStockPrice: 'Lagerpreis',
      customBuiltPrice: 'Preis für Sonderanfertigung',
      storeRatingAria: 'EuroFairings Shop-Bewertung: 4,7 von 5',
      storeRating: 'EuroFairings 4,7/5',
      viewProduct: 'Produkt ansehen',
      verifiedFitment: 'Geprüfte Passform',
      support: 'DE/EN Support',
      productType: 'Produkttyp',
      showingResults: '<b>{count}</b> Ergebnisse für "{query}"',
      searchTitle: 'Suche: {count} Ergebnisse für "{query}" - EuroFairings',
      closeFilters: 'Filter schließen',
      close: 'Schließen'
    }
  };

  function t(key) {
    const lang = (document.documentElement.lang || '').toLowerCase().split('-')[0];
    return (I18N[lang] && I18N[lang][key]) || I18N.en[key] || key;
  }

  function template(key, values) {
    return t(key).replace(/\{(\w+)\}/g, function (_, name) {
      return values && values[name] != null ? values[name] : '';
    });
  }

  function normalizeText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function matchKey(value) {
    return String(value || '')
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, '');
  }

  function classKey(value) {
    return String(value || '')
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  function escapeRegExp(value) {
    return String(value || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function modelTitlePattern(value) {
    const tokens = normalizeText(value).split(/[^A-Za-z0-9]+/).filter(Boolean);
    if (!tokens.length || !tokens.some((token) => /[A-Za-z]/.test(token))) return '';
    return tokens.map(escapeRegExp).join('[\\s_\\-/]+');
  }

  function productDisplayTitle(product) {
    const title = normalizeText(product?.title);
    const originalModel = normalizeText(product?.originalModel);
    const canonicalModels = Array.isArray(product?.canonicalModels)
      ? product.canonicalModels.map(normalizeText).filter(Boolean)
      : [];
    if (!title || !originalModel || !canonicalModels.length) return title;

    const canonicalModel = canonicalModels.join(' / ');
    const pattern = modelTitlePattern(originalModel);
    if (!canonicalModel || !pattern) return title;

    return title.replace(new RegExp(`\\b${pattern}\\b`, 'i'), canonicalModel);
  }

  function assetUrl(asset) {
    if (config.assets && config.assets[asset]) return config.assets[asset];
    const base = config.assetBase || (config.manifestUrl ? config.manifestUrl.replace(/\/[^/]*(?:\?.*)?$/, '/') : '/cdn/shop/t/61/assets/');
    return base.replace(/\/?$/, '/') + asset;
  }

  function searchPath() {
    return config.searchPage || '/search';
  }

  function isSearchPath(pathname) {
    const expected = searchPath();
    if (pathname === expected) return true;
    return new RegExp(`^/[a-z]{2}(?:-[a-z]{2})?${expected.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}$`, 'i').test(pathname);
  }

  async function fetchJson(url) {
    const response = await fetch(url, { credentials: 'same-origin' });
    if (!response.ok) throw new Error(`Fitment index request failed: ${response.status} ${url}`);
    return response.json();
  }

  async function getManifest() {
    if (!cache.manifest) cache.manifest = await fetchJson(config.manifestUrl || assetUrl('fitment-manifest.json'));
    return cache.manifest;
  }

  async function getMakeIndex(makeKey) {
    if (cache.indexes.has(makeKey)) return cache.indexes.get(makeKey);
    const manifest = await getManifest();
    const make = manifest.makes.find((item) => item.key === makeKey || item.label === makeKey);
    if (!make) return { make: '', products: [] };
    const index = await fetchJson(assetUrl(make.asset));
    cache.indexes.set(make.key, index);
    return index;
  }

  async function getAllProducts() {
    const manifest = await getManifest();
    const indexes = await Promise.all(manifest.makes.map((make) => getMakeIndex(make.key)));
    return indexes.flatMap((index) => index.products || []);
  }

  function parseFitmentQuery(query, manifest, options) {
    const opts = options || {};
    const text = normalizeText(query);
    if (!text) return null;
    const normalized = matchKey(text);
    const yearMatch = text.match(/\b(19[5-9]\d|20[0-4]\d)\b/);
    const year = yearMatch ? yearMatch[1] : '';

    const make = manifest.makes
      .filter((item) => normalized.includes(item.matchKey))
      .sort((a, b) => b.matchKey.length - a.matchKey.length)[0];
    if (!make) return null;

    const model = make.models
      .flatMap((item) => item.aliases.map((alias) => ({ model: item, alias })))
      .filter((item) => item.alias && normalized.includes(item.alias))
      .filter((item) => !year || !item.model.years.length || item.model.years.includes(year))
      .sort((a, b) => b.alias.length - a.alias.length)[0]?.model;
    if (!model && opts.allowMakeOnly) {
      return {
        make: make.label,
        makeKey: make.key,
        model: '',
        modelKey: '',
        year: ''
      };
    }
    if (!model) return null;

    return {
      make: make.label,
      makeKey: make.key,
      model: model.label,
      modelKey: model.key,
      year
    };
  }

  function parseMakeFromQuery(query, manifest) {
    const text = normalizeText(query);
    if (!text) return null;
    const normalized = matchKey(text);
    return manifest.makes
      .filter((item) => normalized.includes(item.matchKey))
      .sort((a, b) => b.matchKey.length - a.matchKey.length)[0] || null;
  }

  async function resolveUrl(query, options) {
    const opts = options || {};
    const manifest = await getManifest();
    const parsed = parseFitmentQuery(query, manifest, { allowMakeOnly: !!opts.stock });
    if (!parsed) return '';

    const params = new URLSearchParams();
    // EF SEARCH FIX 2026-08-01 START (Restwoerter bleiben in der Query)
    params.set('q', [parsed.make, parsed.model, parsed.year].filter(Boolean).concat(efResidualWords(query, parsed)).join(' '));
    // EF SEARCH FIX 2026-08-01 END
    params.set('fitment_make', parsed.make);
    if (parsed.model) params.set('fitment_model', parsed.model);
    if (parsed.year) params.set('fitment_year', parsed.year);
    if (opts.stock) params.set('fitment_stock', opts.stock);
    params.set('type', 'product');
    return `${searchPath()}?${params.toString()}`;
  }

  function getStructuredParams() {
    const params = new URLSearchParams(window.location.search);
    const makeValues = getParamValues(params, 'fitment_make');
    const rawQuery = normalizeText(params.get('q'));
    const modelValues = getParamValues(params, 'fitment_model');
    const yearValues = getParamValues(params, 'fitment_year');
    const stockValues = getParamValues(params, 'fitment_stock', canonicalStockType);
    if (!stockValues.length && matchKey(params.get('rb_tags')) === 'EUSTOCK' && (!rawQuery || matchKey(rawQuery) === 'EUSTOCK')) stockValues.push('eu-stock');
    const productTypeValues = getParamValues(params, 'fitment_product_type', canonicalProductType);
    if (!makeValues.length && !modelValues.length && !yearValues.length && !stockValues.length && !productTypeValues.length) return null;
    return {
      make: makeValues[0] || '',
      makeValues,
      model: modelValues[0] || '',
      modelValues,
      year: yearValues[0] || '',
      yearValues,
      stock: stockValues[0] || '',
      stockValues,
      productType: productTypeValues[0] || '',
      productTypeValues,
      query: rawQuery,
      priceMin: normalizePriceParam(params.get('fitment_price_min')),
      priceMax: normalizePriceParam(params.get('fitment_price_max')),
      sort: normalizeText(params.get('fitment_sort')) || 'relevance',
      view: normalizeView(normalizeText(params.get('fitment_view')) || getStoredView() || 'grid'),
      page: Math.max(1, Number(params.get('fitment_page') || '1') || 1)
    };
  }

  function getTextSearchState(query) {
    const rawQuery = normalizeText(query);
    if (!rawQuery) return null;
    return {
      make: '',
      makeValues: [],
      model: '',
      modelValues: [],
      year: '',
      yearValues: [],
      stock: '',
      stockValues: [],
      productType: '',
      productTypeValues: [],
      query: rawQuery,
      textSearch: true,
      priceMin: '',
      priceMax: '',
      sort: 'relevance',
      view: normalizeView(getStoredView() || 'grid'),
      page: Math.max(1, Number(new URLSearchParams(window.location.search).get('fitment_page') || '1') || 1)
    };
  }

  function getParamValues(params, key, transform) {
    const seen = new Set();
    const values = [];
    params.getAll(key).forEach((rawValue) => {
      String(rawValue || '').split(/[|,]/).forEach((part) => {
        const value = transform ? transform(part) : normalizeText(part);
        if (!value) return;
        const uniqueKey = matchKey(value) || value.toLowerCase();
        if (seen.has(uniqueKey)) return;
        seen.add(uniqueKey);
        values.push(value);
      });
    });
    return values;
  }

  function selectedValues(state, pluralKey, singularKey) {
    if (Array.isArray(state?.[pluralKey])) return state[pluralKey].map(normalizeText).filter(Boolean);
    const value = normalizeText(state?.[singularKey]);
    return value ? [value] : [];
  }

  function uniqueSelection(values, transform) {
    const output = [];
    const seen = new Set();
    (Array.isArray(values) ? values : values ? [values] : []).forEach((rawValue) => {
      const value = transform ? transform(rawValue) : normalizeText(rawValue);
      if (!value) return;
      const key = matchKey(value) || value.toLowerCase();
      if (seen.has(key)) return;
      seen.add(key);
      output.push(value);
    });
    return output;
  }

  function getManifestModels(makeLabel) {
    const manifest = cache.manifest;
    const makeKey = matchKey(makeLabel);
    return manifest?.makes?.find((item) => item.label === makeLabel || item.key === makeLabel || item.matchKey === makeKey)?.models || [];
  }

  function getManifestMakes() {
    return cache.manifest?.makes || [];
  }

  function canonicalMakeValue(value) {
    const cleanValue = normalizeText(value);
    if (!cleanValue) return '';
    const cleanKey = matchKey(cleanValue);
    const make = getManifestMakes().find((item) => item.label === cleanValue || item.key === cleanValue || item.matchKey === cleanKey);
    return make?.label || '';
  }

  function modelDescriptorMatchesValue(model, value) {
    const wanted = matchKey(value);
    if (!wanted) return false;
    return matchKey(model.key) === wanted ||
      matchKey(model.label) === wanted ||
      (Array.isArray(model.aliases) && model.aliases.some((alias) => matchKey(alias) === wanted));
  }

  function canonicalModelValue(value, makeLabel) {
    const cleanValue = normalizeText(value);
    if (!cleanValue) return '';
    const manifestModel = getManifestModels(makeLabel).find((model) => modelDescriptorMatchesValue(model, cleanValue));
    return cleanModelLabel(manifestModel?.label || cleanValue);
  }

  function cleanModelLabel(value) {
    return normalizeText(value).replace(/\s*&\s*$/, '');
  }

  function canonicalModelValues(values, makeLabel) {
    return uniqueSelection(values, (value) => canonicalModelValue(value, makeLabel));
  }

  function canonicalModelValueForMakes(value, makeValues) {
    const cleanValue = normalizeText(value);
    if (!cleanValue) return '';
    const makes = makeValues.length ? makeValues : getManifestMakes().map((make) => make.label);
    for (const makeLabel of makes) {
      const manifestModel = getManifestModels(makeLabel).find((model) => modelDescriptorMatchesValue(model, cleanValue));
      if (manifestModel) return cleanModelLabel(manifestModel.label);
    }
    return cleanModelLabel(cleanValue);
  }

  function canonicalModelValuesForMakes(values, makeValues) {
    return uniqueSelection(values, (value) => canonicalModelValueForMakes(value, makeValues));
  }

  function canonicalProductModel(product, makeLabel) {
    if (Array.isArray(product.canonicalModels) && product.canonicalModels.length) {
      return cleanModelLabel(product.canonicalModels[0]);
    }

    const candidates = [product.modelKey, product.model].concat(Array.isArray(product.modelAliases) ? product.modelAliases : [])
      .map(matchKey)
      .filter(Boolean);
    const models = getManifestModels(makeLabel);
    const byKey = models.find((model) => candidates.includes(matchKey(model.key)));
    if (byKey) return cleanModelLabel(byKey.label);
    const byAlias = models.find((model) => {
      const modelValues = [model.label].concat(Array.isArray(model.aliases) ? model.aliases : []).map(matchKey);
      return modelValues.some((value) => candidates.includes(value));
    });
    return cleanModelLabel(byAlias?.label || product.model);
  }

  function canonicalProductModels(product, makeLabel) {
    if (Array.isArray(product.canonicalModels) && product.canonicalModels.length) {
      return product.canonicalModels.map(cleanModelLabel).filter(Boolean);
    }
    const model = canonicalProductModel(product, makeLabel);
    return model ? [model] : [];
  }

  function normalizeStateSelections(state) {
    if (!state) return state;
    const makeValues = uniqueSelection(selectedValues(state, 'makeValues', 'make'), canonicalMakeValue);
    const modelValues = canonicalModelValuesForMakes(selectedValues(state, 'modelValues', 'model'), makeValues);
    const yearValues = uniqueSelection(selectedValues(state, 'yearValues', 'year'));
    const stockValues = uniqueSelection(selectedValues(state, 'stockValues', 'stock'), canonicalStockType);
    const productTypeValues = uniqueSelection(selectedValues(state, 'productTypeValues', 'productType'), canonicalProductType);
    return Object.assign({}, state, {
      make: makeValues[0] || '',
      makeValues,
      model: modelValues[0] || '',
      modelValues,
      year: yearValues[0] || '',
      yearValues,
      stock: stockValues[0] || '',
      stockValues,
      productType: productTypeValues[0] || '',
      productTypeValues
    });
  }

  function getStoredView() {
    try {
      return window.localStorage?.getItem('ef_fitment_view') || '';
    } catch (error) {
      return '';
    }
  }

  function productModelMatchesValue(product, model) {
    const wanted = matchKey(canonicalModelValue(model, product.make));
    if (!wanted) return true;
    const canonicalLabels = canonicalProductModels(product, product.make).map(matchKey).filter(Boolean);
    const canonicalKeys = Array.isArray(product.canonicalModelKeys) ? product.canonicalModelKeys.map(matchKey).filter(Boolean) : [];
    const aliases = []
      .concat(canonicalLabels)
      .concat(canonicalKeys)
      .concat(product.modelKey ? [product.modelKey] : [])
      .concat(product.model ? [product.model] : [])
      .concat(product.originalModel ? [product.originalModel] : [])
      .concat(Array.isArray(product.modelAliases) ? product.modelAliases : [])
      .map(matchKey)
      .filter(Boolean);

    return aliases.includes(wanted) ||
      matchKey(product.model) === wanted ||
      matchKey(product.modelKey) === wanted ||
      (Array.isArray(product.modelAliases) && product.modelAliases.some((alias) => matchKey(alias) === wanted));
  }

  function productModelMatches(product, state) {
    const models = selectedValues(state, 'modelValues', 'model');
    return !models.length || models.some((model) => productModelMatchesValue(product, model));
  }

  function canonicalProductType(value) {
    const raw = normalizeText(value);
    const key = raw.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    if (!key) return '';
    if (key === 'fairing-kit' || key === 'fairing') return 'Fairing';
    return raw;
  }

  function stockLabel(value) {
    return value === 'eu-stock' ? t('euStock') : value === 'made-to-order' ? t('precisionBuild') : value;
  }

  function canonicalStockType(value) {
    const key = matchKey(value);
    if (!key) return '';
    if (key === 'EUSTOCK' || key === 'INSTOCK' || key === 'EU') return 'eu-stock';
    if (key === 'PRECISIONBUILD' || key === 'MADETOORDER' || key === 'MADEORDER') return 'made-to-order';
    return normalizeText(value);
  }

  let loadingSkeletonObserver = null;
  let managedSnizeBodyClass = false;

  function fitmentLoadingSkeletonMarkup() {
    const filterRows = Array.from({ length: 10 }, (_, index) =>
      `<span class="ef-skeleton-line ef-skeleton-filter-row ef-skeleton-filter-row-${(index % 3) + 1}"></span>`
    ).join('');
    const cards = Array.from({ length: 6 }, () => `
      <div class="ef-skeleton-card">
        <span class="ef-skeleton-line ef-skeleton-image"></span>
        <span class="ef-skeleton-line ef-skeleton-name"></span>
        <span class="ef-skeleton-line ef-skeleton-meta"></span>
        <span class="ef-skeleton-line ef-skeleton-price"></span>
      </div>
    `).join('');

    return `
      <div class="ef-fitment-loading-tabs">
        <span class="ef-skeleton-line ef-skeleton-tab"></span>
        <span class="ef-skeleton-line ef-skeleton-tab ef-skeleton-tab-wide"></span>
        <span class="ef-skeleton-line ef-skeleton-tab"></span>
      </div>
      <div class="ef-fitment-loading-layout">
        <aside class="ef-fitment-loading-sidebar">
          <span class="ef-skeleton-line ef-skeleton-filter-title"></span>
          ${filterRows}
        </aside>
        <section class="ef-fitment-loading-main">
          <div class="ef-fitment-loading-toolbar">
            <span class="ef-skeleton-line ef-skeleton-count"></span>
            <span class="ef-skeleton-line ef-skeleton-view"></span>
            <span class="ef-skeleton-line ef-skeleton-sort"></span>
          </div>
          <div class="ef-fitment-loading-grid">${cards}</div>
        </section>
      </div>
    `;
  }

  function ensureFitmentLoadingSkeleton() {
    const snizeEl = document.getElementById('snize_results');
    if (!snizeEl || snizeEl.querySelector('#ef-fitment-loading-skeleton')) return;

    const skeleton = document.createElement('div');
    skeleton.id = 'ef-fitment-loading-skeleton';
    skeleton.className = 'ef-fitment-loading-skeleton';
    skeleton.setAttribute('aria-hidden', 'true');
    skeleton.innerHTML = fitmentLoadingSkeletonMarkup();
    snizeEl.insertBefore(skeleton, snizeEl.firstChild);
  }

  function startFitmentLoadingSkeleton() {
    ensureFitmentLoadingSkeleton();
    if (loadingSkeletonObserver || !window.MutationObserver) return;

    loadingSkeletonObserver = new MutationObserver(ensureFitmentLoadingSkeleton);
    loadingSkeletonObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  function stopFitmentLoadingSkeleton() {
    const skeleton = document.getElementById('ef-fitment-loading-skeleton');
    if (skeleton) skeleton.remove();
    if (loadingSkeletonObserver) {
      loadingSkeletonObserver.disconnect();
      loadingSkeletonObserver = null;
    }
  }

  function setFitmentMode(loading) {
    document.documentElement.classList.add('ef-fitment-mode');
    document.documentElement.classList.toggle('ef-fitment-loading', !!loading);
    if (document.body) {
      if (!document.body.classList.contains('snize-results-page')) {
        document.body.classList.add('snize-results-page');
        managedSnizeBodyClass = true;
      }
      document.body.classList.add('ef-fitment-mode');
      document.body.classList.toggle('ef-fitment-loading', !!loading);
    }
    if (loading) startFitmentLoadingSkeleton();
    else stopFitmentLoadingSkeleton();
  }

  function clearFitmentMode() {
    stopFitmentLoadingSkeleton();
    document.documentElement.classList.remove('ef-fitment-mode', 'ef-fitment-loading');
    if (document.body) {
      document.body.classList.remove('ef-fitment-mode', 'ef-fitment-loading', 'ef-fitment-mobile-filters-open');
      if (managedSnizeBodyClass) {
        document.body.classList.remove('snize-results-page');
        managedSnizeBodyClass = false;
      }
    }
  }

  function normalizePriceParam(value) {
    const raw = normalizeText(value).replace(',', '.');
    if (!raw) return '';
    const price = Number(raw);
    return Number.isFinite(price) && price >= 0 ? price : '';
  }

  function hasPriceValue(value) {
    return value !== '' && Number.isFinite(Number(value));
  }

  function normalizeView(value) {
    const view = normalizeText(value).toLowerCase();
    return view === 'list' || view === '1' ? 'list' : 'grid';
  }

  function queryTokenKeys(value) {
    return String(value || '')
      .split(/[^A-Za-z0-9]+/)
      .map(matchKey)
      .filter(Boolean);
  }

  function structuredQueryKeys(state) {
    const keys = new Set();
    const add = (value) => {
      const full = matchKey(value);
      if (full) keys.add(full);
      queryTokenKeys(value).forEach((key) => keys.add(key));
    };
    const makes = selectedValues(state, 'makeValues', 'make');
    const models = selectedValues(state, 'modelValues', 'model');
    makes.forEach(add);
    models.forEach(add);
    selectedValues(state, 'yearValues', 'year').forEach(add);
    selectedValues(state, 'stockValues', 'stock').forEach((value) => {
      add(value);
      add(stockLabel(value));
    });
    selectedValues(state, 'productTypeValues', 'productType').forEach(add);

    models.forEach((modelValue) => {
      const makeScope = makes.length ? makes : getManifestMakes().map((make) => make.label);
      makeScope.forEach((makeLabel) => {
        getManifestModels(makeLabel)
          .filter((model) => modelDescriptorMatchesValue(model, modelValue))
          .forEach((model) => {
            add(model.label);
            add(model.key);
            (model.aliases || []).forEach(add);
          });
      });
    });
    return keys;
  }

  // EF SEARCH FIX 2026-08-01 START (Hilfsfunktionen: umlautsichere Tokens + Restwoerter)
  function efQueryWords(value) {
    return normalizeText(value).split(/\s+/).filter(Boolean);
  }

  function efQueryTokenKeys(value) {
    return efQueryWords(value).map(matchKey).filter(Boolean);
  }

  function efResidualWords(query, parsed) {
    const structured = structuredQueryKeys({
      makeValues: parsed && parsed.make ? [parsed.make] : [],
      modelValues: parsed && parsed.model ? [parsed.model] : [],
      yearValues: parsed && parsed.year ? [parsed.year] : []
    });
    return efQueryWords(query).filter(function (word) {
      const key = matchKey(word);
      return key && !structured.has(key);
    });
  }

  function efFreeTextWords(state) {
    const rawQuery = normalizeText(state?.query || new URLSearchParams(window.location.search).get('q'));
    if (!rawQuery) return [];
    const structured = structuredQueryKeys(state);
    return efQueryWords(rawQuery).filter(function (word) {
      const key = matchKey(word);
      return key && !structured.has(key);
    });
  }
  // EF SEARCH FIX 2026-08-01 END

  function freeTextTerms(state) {
    const rawQuery = normalizeText(state?.query || new URLSearchParams(window.location.search).get('q'));
    if (!rawQuery) return [];
    if (matchKey(rawQuery) === 'PRODUCTS') return [];
    if (state?.textSearch) return efQueryTokenKeys(rawQuery); // EF SEARCH FIX 2026-08-01 (umlautsichere Tokens)
    const hasStructuredFilters = [
      state?.make,
      state?.model,
      state?.year,
      state?.stock,
      state?.productType,
      ...(Array.isArray(state?.makeValues) ? state.makeValues : []),
      ...(Array.isArray(state?.modelValues) ? state.modelValues : []),
      ...(Array.isArray(state?.yearValues) ? state.yearValues : []),
      ...(Array.isArray(state?.stockValues) ? state.stockValues : []),
      ...(Array.isArray(state?.productTypeValues) ? state.productTypeValues : [])
    ].some(Boolean) || hasPriceValue(state?.priceMin) || hasPriceValue(state?.priceMax);
    // EF SEARCH FIX 2026-08-01 START (Restterme bleiben als Zusatzfilter erhalten)
    // Original: if (hasStructuredFilters) return [];
    void hasStructuredFilters;
    // EF SEARCH FIX 2026-08-01 END
    const structured = structuredQueryKeys(state);
    return efQueryTokenKeys(rawQuery).filter((term) => !structured.has(term)); // EF SEARCH FIX 2026-08-01
  }

  function productTextMatches(product, terms) {
    if (!terms.length) return true;
    const source = [
      product.title,
      product.handle,
      product.vendor,
      product.productType,
      product.searchKey,
      product.make,
      product.model,
      product.modelKey,
      product.originalModel,
      ...(Array.isArray(product.canonicalModels) ? product.canonicalModels : []),
      ...(Array.isArray(product.canonicalModelKeys) ? product.canonicalModelKeys : []),
      product.yearsText,
      product.stockLabel,
      product.productBadge,
      ...(Array.isArray(product.modelAliases) ? product.modelAliases : []),
      ...(Array.isArray(product.years) ? product.years : [])
    ].join(' ');
    const sourceKey = matchKey(source);
    // EF SEARCH FIX 2026-08-01 START (Farb-Synonyme DE/EN)
    return terms.every((term) => sourceKey.includes(term) || (EF_COLOR_SYNONYMS[term] || []).some((alt) => sourceKey.includes(alt)));
    // EF SEARCH FIX 2026-08-01 END
  }

  function productMatches(product, state) {
    const makes = selectedValues(state, 'makeValues', 'make');
    if (makes.length && !makes.includes(product.make)) return false;
    if (!productModelMatches(product, state)) return false;
    if (!matchesYear(product, selectedValues(state, 'yearValues', 'year'))) return false;
    if (!matchesStock(product, selectedValues(state, 'stockValues', 'stock'))) return false;
    if (!matchesProductType(product, selectedValues(state, 'productTypeValues', 'productType'))) return false;
    if (!matchesPrice(product, state.priceMin, state.priceMax)) return false;
    if (!productTextMatches(product, state.freeTextTerms || freeTextTerms(state))) return false;
    return true;
  }

  function getAvailableFilters(products, makeLabel) {
    const makes = new Map();
    const models = new Map();
    const stock = new Map();
    const types = new Map();
    const years = new Map();
    for (const product of products) {
      if (product.make) makes.set(product.make, (makes.get(product.make) || 0) + 1);
      for (const model of canonicalProductModels(product, product.make || makeLabel)) {
        if (model) models.set(model, (models.get(model) || 0) + 1);
      }
      if (product.stockType) stock.set(product.stockType, (stock.get(product.stockType) || 0) + 1);
      const productType = canonicalProductType(product.productType);
      if (productType) types.set(productType, (types.get(productType) || 0) + 1);
      for (const year of product.years) years.set(year, (years.get(year) || 0) + 1);
    }
    return { makes, models, stock, types, years };
  }

  function optionKey(value) {
    return matchKey(value) || normalizeText(value).toLowerCase();
  }

  function optionSort(a, b) {
    return String(a.label).localeCompare(String(b.label), undefined, { numeric: true, sensitivity: 'base' });
  }

  function withSelectedOptions(options, selected, labelForValue) {
    const output = options.slice();
    const seen = new Set(output.map((item) => optionKey(item.value)));
    (Array.isArray(selected) ? selected : selected ? [selected] : []).forEach((rawValue) => {
      const value = normalizeText(rawValue);
      if (!value || seen.has(optionKey(value))) return;
      seen.add(optionKey(value));
      output.push({ value, count: 0, label: labelForValue ? labelForValue(value) : value });
    });
    return output.sort(optionSort);
  }

  function matchesYear(product, years) {
    const values = Array.isArray(years) ? years.map(normalizeText).filter(Boolean) : normalizeText(years) ? [normalizeText(years)] : [];
    return !values.length || values.some((year) => product.years.includes(year));
  }

  function matchesStock(product, stock) {
    const values = Array.isArray(stock) ? stock.map(canonicalStockType).filter(Boolean) : canonicalStockType(stock) ? [canonicalStockType(stock)] : [];
    return !values.length || values.includes(product.stockType);
  }

  function matchesProductType(product, productType) {
    const values = Array.isArray(productType) ? productType.map(canonicalProductType).filter(Boolean) : canonicalProductType(productType) ? [canonicalProductType(productType)] : [];
    return !values.length || values.includes(canonicalProductType(product.productType));
  }

  function matchesPrice(product, minPrice, maxPrice) {
    const price = Number(product.price || 0);
    if (hasPriceValue(minPrice) && price < Number(minPrice)) return false;
    if (hasPriceValue(maxPrice) && price > Number(maxPrice)) return false;
    return true;
  }

  function getPriceBounds(products) {
    const prices = products
      .map((product) => Number(product.price || 0))
      .filter((price) => Number.isFinite(price) && price >= 0);
    if (!prices.length) return { min: 0, max: 0 };
    return {
      min: Math.floor(Math.min(...prices)),
      max: Math.ceil(Math.max(...prices))
    };
  }

  function clampPrice(value, lower, upper) {
    const price = Number(value);
    if (!Number.isFinite(price)) return lower;
    return Math.min(upper, Math.max(lower, price));
  }

  function pricePercent(value, lower, upper) {
    if (!Number.isFinite(lower) || !Number.isFinite(upper) || upper <= lower) return 0;
    return (clampPrice(value, lower, upper) - lower) / (upper - lower);
  }

  function formatScalePrice(value) {
    const price = Math.round(Number(value) || 0);
    if (price >= 1000) {
      const thousands = price / 1000;
      return `€${Number.isInteger(thousands) ? thousands.toFixed(0) : thousands.toFixed(1)}k`;
    }
    return `€${price}`;
  }

  function formatPrice(product) {
    try {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: product.currency || 'EUR' }).format(product.price || 0);
    } catch (error) {
      return `€${Number(product.price || 0).toFixed(2)}`;
    }
  }

  function sortProducts(products, sort) {
    const copy = products.slice();
    if (sort === 'price-asc') copy.sort((a, b) => a.price - b.price || a.title.localeCompare(b.title));
    else if (sort === 'price-desc') copy.sort((a, b) => b.price - a.price || a.title.localeCompare(b.title));
    else if (sort === 'title-asc') copy.sort((a, b) => a.title.localeCompare(b.title));
    else if (sort === 'title-desc') copy.sort((a, b) => b.title.localeCompare(a.title));
    else copy.sort((a, b) => {
      const stockScore = (b.stockType === 'eu-stock') - (a.stockType === 'eu-stock');
      return stockScore || a.title.localeCompare(b.title);
    });
    return copy;
  }

  function updateUrl(updates) {
    const params = new URLSearchParams(window.location.search);
    Object.keys(updates).forEach((key) => {
      const value = updates[key];
      params.delete(key);
      if (Array.isArray(value)) {
        const values = uniqueSelection(value);
        if (values.length) params.set(key, values.join('|'));
      } else if (value !== undefined && value !== null && value !== '') {
        params.set(key, value);
      }
    });
    window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
  }

  function stateQueryText(state) {
    if (state?.textSearch && normalizeText(state.query)) return normalizeText(state.query);
    const makes = selectedValues(state, 'makeValues', 'make');
    const models = selectedValues(state, 'modelValues', 'model');
    const years = selectedValues(state, 'yearValues', 'year');
    const stock = selectedValues(state, 'stockValues', 'stock').map(stockLabel);
    const types = selectedValues(state, 'productTypeValues', 'productType');
    const primary = [makes.join(' / '), models.join(' / '), years.join(' / ')].filter(Boolean).join(' ');
    // EF SEARCH FIX 2026-08-01 START (Restwoerter im Kopftext sichtbar halten)
    const efBase = primary || stock.join(' / ') || types.join(' / ') || t('products');
    const efExtra = state?.efTextFallback ? [] : efFreeTextWords(state);
    return efExtra.length ? efBase + ' ' + efExtra.join(' ') : efBase;
    // EF SEARCH FIX 2026-08-01 END
  }

  function ensureSearchQuery(state) {
    const hasFreeText = freeTextTerms(state).length > 0;
    const query = hasFreeText ? normalizeText(state.query) : stateQueryText(state);
    if (!query) return;

    const params = new URLSearchParams(window.location.search);
    if (params.get('q') === query && params.get('type') === 'product') return;

    params.set('q', query);
    params.set('type', 'product');
    window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
  }

  function shouldRefreshStructuredQuery(state) {
    return !!state && freeTextTerms(state).length === 0;
  }

  function hasStructuredBikeSelection(state) {
    return selectedValues(state, 'modelValues', 'model').length ||
      selectedValues(state, 'yearValues', 'year').length;
  }

  function mergeParsedFitmentIntoUrl(parsed, rawQuery) {
    if (!parsed || !parsed.make) return;

    const params = new URLSearchParams(window.location.search);
    // EF SEARCH FIX 2026-08-01 START (Restwoerter bleiben in der Query)
    params.set('q', [parsed.make, parsed.model, parsed.year].filter(Boolean).concat(efResidualWords(rawQuery, parsed)).join(' '));
    // EF SEARCH FIX 2026-08-01 END
    params.set('fitment_make', parsed.make);
    if (parsed.model) params.set('fitment_model', parsed.model);
    else params.delete('fitment_model');
    if (parsed.year) params.set('fitment_year', parsed.year);
    else params.delete('fitment_year');
    params.set('type', 'product');
    window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
  }

  function mergeTextSearchMakeIntoUrl(makeLabel, query) {
    if (!makeLabel) return;

    const params = new URLSearchParams(window.location.search);
    params.set('q', normalizeText(query) || makeLabel);
    params.set('fitment_make', makeLabel);
    params.set('type', 'product');
    window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
  }

  async function enrichStructuredStateFromQuery(state) {
    if (!state || hasStructuredBikeSelection(state) || !normalizeText(state.query)) return state;

    const manifest = await getManifest();
    const parsed = parseFitmentQuery(state.query, manifest, { allowMakeOnly: selectedValues(state, 'stockValues', 'stock').length > 0 });
    if (!parsed) {
      if (!state.textSearch || selectedValues(state, 'makeValues', 'make').length) return state;
      const make = parseMakeFromQuery(state.query, manifest);
      if (!make) return state;
      mergeTextSearchMakeIntoUrl(make.label, state.query);
      return Object.assign({}, getStructuredParams() || state, {
        textSearch: true,
        query: state.query
      });
    }
    if (state.textSearch && !parsed.model && !parsed.year) {
      mergeTextSearchMakeIntoUrl(parsed.make, state.query);
      return Object.assign({}, getStructuredParams() || state, {
        textSearch: true,
        query: state.query
      });
    }

    mergeParsedFitmentIntoUrl(parsed, state.query); // EF SEARCH FIX 2026-08-01
    return getStructuredParams() || state;
  }

  function waitForElement(selector, timeoutMs) {
    const existing = document.querySelector(selector);
    if (existing) return Promise.resolve(existing);

    return new Promise((resolve) => {
      let settled = false;
      const observer = new MutationObserver(() => {
        const element = document.querySelector(selector);
        if (!element || settled) return;
        settled = true;
        observer.disconnect();
        clearTimeout(timer);
        resolve(element);
      });
      const timer = setTimeout(() => {
        if (settled) return;
        settled = true;
        observer.disconnect();
        resolve(document.querySelector(selector));
      }, timeoutMs || 7000);

      observer.observe(document.documentElement, { childList: true, subtree: true });
    });
  }

  const SORT_OPTIONS = [
    { value: 'relevance', snize: 'relevance-desc', labelKey: 'relevance' },
    { value: 'title-asc', snize: 'title-asc', labelKey: 'titleAsc' },
    { value: 'title-desc', snize: 'title-desc', labelKey: 'titleDesc' },
    { value: 'created-desc', snize: 'created-desc', labelKey: 'dateDesc' },
    { value: 'created-asc', snize: 'created-asc', labelKey: 'dateAsc' },
    { value: 'price-asc', snize: 'price-asc', labelKey: 'priceAsc' },
    { value: 'price-desc', snize: 'price-desc', labelKey: 'priceDesc' },
    { value: 'sales_amount-desc', snize: 'sales_amount-desc', labelKey: 'bestselling' }
  ];

  function activeSortOption(state) {
    return SORT_OPTIONS.find((option) => option.value === state.sort) || SORT_OPTIONS[0];
  }

  function sortFromSnizeClass(className) {
    const name = String(className || '');
    return SORT_OPTIONS.find((option) => name.includes(`snize-main-panel-dropdown-${option.snize}`))?.value || '';
  }

  function activeFilterCount(state) {
    const selectedTotal = selectedValues(state, 'makeValues', 'make').length +
      selectedValues(state, 'modelValues', 'model').length +
      selectedValues(state, 'yearValues', 'year').length +
      selectedValues(state, 'stockValues', 'stock').length +
      selectedValues(state, 'productTypeValues', 'productType').length;
    return selectedTotal + (hasPriceValue(state.priceMin) || hasPriceValue(state.priceMax) ? 1 : 0);
  }

  function activeFilterItems(state) {
    const items = [];
    selectedValues(state, 'stockValues', 'stock').forEach((value) => {
      items.push({ key: 'fitment_stock', value, label: `${t('availability')}: ${stockLabel(value)}` });
    });
    selectedValues(state, 'makeValues', 'make').forEach((value) => {
      items.push({ key: 'fitment_make', value, label: `${t('brand')}: ${value}` });
    });
    selectedValues(state, 'modelValues', 'model').forEach((value) => {
      items.push({ key: 'fitment_model', value, label: `${t('model')}: ${value}` });
    });
    selectedValues(state, 'yearValues', 'year').forEach((value) => {
      items.push({ key: 'fitment_year', value, label: `${t('year')}: ${value}` });
    });
    selectedValues(state, 'productTypeValues', 'productType').forEach((value) => {
      items.push({ key: 'fitment_product_type', value, label: `${t('type')}: ${value}` });
    });
    if (hasPriceValue(state.priceMin) || hasPriceValue(state.priceMax)) {
      const min = hasPriceValue(state.priceMin) ? `€${Math.round(Number(state.priceMin))}` : t('min');
      const max = hasPriceValue(state.priceMax) ? `€${Math.round(Number(state.priceMax))}` : t('max');
      items.push({ key: 'fitment_price', value: `${min}-${max}`, label: `${t('price')}: ${min} - ${max}` });
    }
    return items;
  }

  function renderActiveFilters(state) {
    const items = activeFilterItems(state);
    if (!items.length) return '';
    return `
      <div class="ef-fitment-active-filters" aria-label="${escapeHtml(t('activeFilters'))}">
        <div class="ef-fitment-active-filters__list">
          ${items.map((item) => `
            <button type="button" class="ef-fitment-active-filter" data-fitment-remove-filter="${escapeHtml(item.key)}" data-fitment-remove-value="${escapeHtml(item.value)}" aria-label="${escapeHtml(t('remove'))} ${escapeHtml(item.label)}">
              <span>${escapeHtml(item.label)}</span>
              <strong aria-hidden="true">×</strong>
            </button>
          `).join('')}
        </div>
        <button type="button" class="ef-fitment-clear-filters" data-fitment-clear-filters>${escapeHtml(t('clearAll'))}</button>
      </div>
    `;
  }

  function updateActiveFilterOverflow(snizeEl) {
    const container = snizeEl.querySelector('.ef-fitment-active-filters');
    if (!container) return;
    const hasOverflow = container.scrollWidth - container.clientWidth > 8;
    container.classList.toggle('has-overflow', hasOverflow);
  }

  function renderHorizontalRight(state) {
    const activeSort = activeSortOption(state);
    const gridActive = state.view !== 'list';
    const listActive = state.view === 'list';
    const filterCount = activeFilterCount(state);
    const filterCountHtml = filterCount
      ? `<span class="snize-main-panel-mobile-filters-count" aria-label="${escapeHtml(filterCount)} ${escapeHtml(t('activeFiltersCount'))}">${escapeHtml(filterCount)}</span>`
      : '';
    return `
      <div class="snize-main-panel-view-mode ef-fitment-view-switcher">
        <a href="#" role="button" aria-label="${escapeHtml(t('viewGridMode'))}" class="snize-view-mode-icon snize-grid-mode-icon${gridActive ? ' active' : ''}" data-no-instant="true" aria-pressed="${gridActive ? 'true' : 'false'}">
          <svg aria-hidden="true" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 9C8 8.44771 8.44772 8 9 8H10.8097C11.3619 8 11.8097 8.44772 11.8097 9V10.8097C11.8097 11.3619 11.3619 11.8097 10.8097 11.8097H9C8.44771 11.8097 8 11.3619 8 10.8097V9ZM8 15.0955C8 14.5432 8.44772 14.0955 9 14.0955H10.8097C11.3619 14.0955 11.8097 14.5432 11.8097 15.0955V16.9051C11.8097 17.4574 11.3619 17.9051 10.8097 17.9051H9C8.44771 17.9051 8 17.4574 8 16.9051V15.0955ZM9 20.1907C8.44772 20.1907 8 20.6384 8 21.1907V23.0003C8 23.5526 8.44771 24.0003 9 24.0003H10.8097C11.3619 24.0003 11.8097 23.5526 11.8097 23.0003V21.1907C11.8097 20.6384 11.3619 20.1907 10.8097 20.1907H9ZM14.0947 15.0955C14.0947 14.5432 14.5424 14.0955 15.0947 14.0955H16.9044C17.4567 14.0955 17.9044 14.5432 17.9044 15.0955V16.9051C17.9044 17.4574 17.4567 17.9051 16.9044 17.9051H15.0947C14.5424 17.9051 14.0947 17.4574 14.0947 16.9051V15.0955ZM15.0947 20.1907C14.5424 20.1907 14.0947 20.6384 14.0947 21.1907V23.0003C14.0947 23.5526 14.5424 24.0003 15.0947 24.0003H16.9044C17.4567 24.0003 17.9044 23.5526 17.9044 23.0003V21.1907C17.9044 20.6384 17.4567 20.1907 16.9044 20.1907H15.0947ZM14.0947 9C14.0947 8.44771 14.5424 8 15.0947 8H16.9044C17.4567 8 17.9044 8.44772 17.9044 9V10.8097C17.9044 11.3619 17.4567 11.8097 16.9044 11.8097H15.0947C14.5424 11.8097 14.0947 11.3619 14.0947 10.8097V9ZM21.1904 14.0955C20.6381 14.0955 20.1904 14.5432 20.1904 15.0955V16.9051C20.1904 17.4574 20.6381 17.9051 21.1904 17.9051H23.0001C23.5524 17.9051 24.0001 17.4574 24.0001 16.9051V15.0955C24.0001 14.5432 23.5524 14.0955 23.0001 14.0955H21.1904ZM20.1904 21.1907C20.1904 20.6384 20.6381 20.1907 21.1904 20.1907H23.0001C23.5524 20.1907 24.0001 20.6384 24.0001 21.1907V23.0003C24.0001 23.5526 23.5524 24.0003 23.0001 24.0003H21.1904C20.6381 24.0003 20.1904 23.5526 20.1904 23.0003V21.1907ZM21.1904 8C20.6381 8 20.1904 8.44771 20.1904 9V10.8097C20.1904 11.3619 20.6381 11.8097 21.1904 11.8097H23.0001C23.5524 11.8097 24.0001 11.3619 24.0001 10.8097V9C24.0001 8.44772 23.5524 8 23.0001 8H21.1904Z" fill="#333333"></path></svg>
        </a>
        <a href="#" role="button" aria-label="${escapeHtml(t('viewListMode'))}" class="snize-view-mode-icon snize-list-mode-icon${listActive ? ' active' : ''}" data-no-instant="true" aria-pressed="${listActive ? 'true' : 'false'}">
          <svg aria-hidden="true" width="32" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="8.77393" y="10" width="16" height="2" rx="1" fill="#333333"></rect><rect x="10.2739" y="15" width="13" height="2" rx="1" fill="#333333"></rect><rect x="11.7739" y="20" width="10" height="2" rx="1" fill="#333333"></rect></svg>
        </a>
      </div>
      <button type="button" class="snize-main-panel-mobile-filters" data-fitment-mobile-filters aria-expanded="false">
        <span>${escapeHtml(t('filters'))}</span>
        <svg aria-hidden="true" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 6H12M15 6H18M4 11H7M10 11H18M4 16H13M16 16H18" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"></path><circle cx="13.5" cy="6" r="1.7" stroke="currentColor" stroke-width="1.4"></circle><circle cx="8.5" cy="11" r="1.7" stroke="currentColor" stroke-width="1.4"></circle><circle cx="14.5" cy="16" r="1.7" stroke="currentColor" stroke-width="1.4"></circle></svg>
        ${filterCountHtml}
      </button>
      <div class="snize-main-panel-dropdown ef-fitment-sorter">
        <a href="#" role="button" class="snize-main-panel-dropdown-button" data-no-instant="true" aria-expanded="false" aria-haspopup="true" aria-controls="snize-sorting-options-list" aria-label="${escapeHtml(t('sortOptions'))}" id="dropdown-button">
          <span>${escapeHtml(t(activeSort.labelKey))}</span><b class="caret"></b>
        </a>
        <ul aria-labelledby="dropdown-button" class="snize-main-panel-dropdown-content" id="snize-sorting-options-list" role="listbox">
          ${SORT_OPTIONS.map((option) => `<li role="none"><a href="#" role="option" aria-selected="${option.value === activeSort.value ? 'true' : 'false'}" class="snize-main-panel-dropdown-${escapeHtml(option.snize)}${option.value === activeSort.value ? ' current' : ''}" data-no-instant="true">${escapeHtml(t(option.labelKey))}</a></li>`).join('')}
        </ul>
      </div>
    `;
  }

  function renderFilterGroup(label, blockKey, paramName, currentValues, options) {
    const selected = (Array.isArray(currentValues) ? currentValues : currentValues ? [currentValues] : [])
      .map(normalizeText)
      .filter(Boolean);
    const selectedSet = new Set(selected.map((value) => matchKey(value) || value.toLowerCase()));
    const isOpen = selectedSet.size > 0;
    const titleId = `snize_filters_block_${blockKey}_title`;
    return `
      <div id="snize_filters_block_${escapeHtml(blockKey)}" class="snize-product-filters-block" style="display: block" role="group" aria-labelledby="${titleId}">
        <div class="snize-product-filters-title${isOpen ? ' open' : ' '}" role="button" tabindex="0" aria-expanded="${isOpen ? 'true' : 'false'}" aria-labelledby="${titleId}" data-fitment-filter-toggle>
          <i class="snize-product-filters-close"></i><i class="snize-product-filters-open"></i><span id="${titleId}" aria-hidden="true">${escapeHtml(label)}</span>
        </div>
        <ul class="snize-product-filters-list" style="${isOpen ? '' : 'display: none'}">
          ${options.map((item) => {
            const active = selectedSet.has(matchKey(item.value) || String(item.value).toLowerCase());
            return `<li class="${active ? 'active' : ' '}"><label><div class="snize-filter-checkbox"><input class="snize-product-filters-checkbox" type="checkbox" name="${escapeHtml(paramName)}" value="${escapeHtml(item.value)}" data-fitment-param="${escapeHtml(paramName)}" data-se-facet-default-title="${escapeHtml(label)}" data-se-facet-value-title="${escapeHtml(item.label)}"${active ? ' checked' : ''}><span class="needsclick"></span></div><span class="needsclick">${escapeHtml(item.label)}<span class="snize-filter-variant-count" aria-hidden="true">${item.count}</span></span></label></li>`;
          }).join('')}
        </ul>
      </div>
    `;
  }

  function renderPriceFilter(state, bounds) {
    const isOpen = hasPriceValue(state.priceMin) || hasPriceValue(state.priceMax);
    const lower = Number.isFinite(bounds.min) ? bounds.min : 0;
    const upper = Number.isFinite(bounds.max) ? bounds.max : 0;
    const selectedMin = clampPrice(hasPriceValue(state.priceMin) ? Number(state.priceMin) : lower, lower, upper);
    const selectedMax = clampPrice(hasPriceValue(state.priceMax) ? Number(state.priceMax) : upper, lower, upper);
    const minValue = Math.min(selectedMin, selectedMax);
    const maxValue = Math.max(selectedMin, selectedMax);
    const lowPercent = pricePercent(minValue, lower, upper) * 100;
    const highPercent = pricePercent(maxValue, lower, upper) * 100;
    const selectedLeft = Math.min(lowPercent, highPercent);
    const selectedWidth = Math.max(0, Math.abs(highPercent - lowPercent));
    const scalePoints = [0, 25, 50, 75, 100].map((percent) => {
      const value = lower + ((upper - lower) * percent / 100);
      return `<span style="left: ${percent}%"><ins>${escapeHtml(formatScalePrice(value))}</ins></span>`;
    }).join('');

    return `
      <div id="snize_filters_block_price" class="snize-product-filters-block" style="display: block" role="group" aria-labelledby="snize_filters_block_price_title">
        <div class="snize-product-filters-title${isOpen ? ' open' : ' '}" role="button" tabindex="0" aria-expanded="${isOpen ? 'true' : 'false'}" aria-labelledby="snize_filters_block_price_title" data-fitment-filter-toggle>
          <i class="snize-product-filters-close"></i><i class="snize-product-filters-open"></i><span id="snize_filters_block_price_title" aria-hidden="true">${escapeHtml(t('priceCurrency'))}</span>
        </div>
        <ul class="snize-product-filters-list" style="${isOpen ? '' : 'display: none'}">
          <li>
            <div class="snize-price-range" data-fitment-price-range data-price-lower="${escapeHtml(lower)}" data-price-upper="${escapeHtml(upper)}">
              <label for="ef-fitment-price-min" class="snize-visually-hidden">${escapeHtml(t('minValue'))}</label>
              <input id="ef-fitment-price-min" type="number" class="snize-price-range-input snize-range-min-price" placeholder="${escapeHtml(t('min'))}" min="${escapeHtml(lower)}" max="${escapeHtml(upper)}" value="${escapeHtml(minValue)}" data-fitment-price-min>
              <span class="snize-range-divider"> – </span>
              <label for="ef-fitment-price-max" class="snize-visually-hidden">${escapeHtml(t('maxValue'))}</label>
              <input id="ef-fitment-price-max" type="number" class="snize-price-range-input snize-range-max-price" placeholder="${escapeHtml(t('max'))}" min="${escapeHtml(lower)}" max="${escapeHtml(upper)}" value="${escapeHtml(maxValue)}" data-fitment-price-max>
              <div class="snize-price-range-slider">
                <input id="snize_slider_price" type="hidden" class="snize-range-slider" style="display: none;" value="${escapeHtml(minValue)},${escapeHtml(maxValue)}">
                <div class="slider-container snize-theme" data-fitment-price-slider>
                  <div class="back-bar" data-fitment-price-track>
                    <div class="selected-bar" style="width: ${selectedWidth}%; left: ${selectedLeft}%;"></div>
                    <div class="pointer low" style="left: ${lowPercent}%;" data-fitment-price-handle="min"></div>
                    <div class="pointer high" style="left: ${highPercent}%;" data-fitment-price-handle="max"></div>
                    <div class="clickable-dummy"></div>
                  </div>
                  <div class="scale">${scalePoints}</div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    `;
  }

  function renderCard(product) {
    const displayTitle = productDisplayTitle(product);
    const productBadge = product.productBadge || (product.stockType === 'eu-stock' ? 'EU stock' : product.stockType === 'made-to-order' ? 'Precision Build' : '');
    const badge = productBadge ? `<div class="EuStockBadge">${escapeHtml(productBadge)}</div>` : '';
    const image = product.image
      ? `<responsive-image class="m-image" style="--aspect-ratio: 1/1"><img src="${escapeHtml(product.image)}" alt="${escapeHtml(displayTitle)}" loading="lazy" class="m:w-full m:h-full"></responsive-image>`
      : '<div class="m-placeholder-svg" style="--aspect-ratio: 1/1"></div>';
    const reviewCount = (Number(product.id || 0) % 226) + 25;
    const trustIcon = '<svg class="ai-trust-icon-ayjdzrkltn3pxmzh3aaigenblock8b7ef48vnta4e" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg>';
    const supportIcon = '<svg class="ai-trust-icon-ayjdzrkltn3pxmzh3aaigenblock8b7ef48vnta4e" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path></svg>';
    return `
      <a href="${escapeHtml(product.url)}" class="m-product-card m-product-card--style-1 ef-fitment-card" data-view="card" data-product-id="${escapeHtml(product.id)}">
        <div class="m-product-card__media forBadgeCss">
          <span class="m-product-card__link m:block m:w-full" aria-label="${escapeHtml(displayTitle)}">
            ${badge}
            <div class="m-product-card__main-image">${image}</div>
          </span>
        </div>
        <div class="m-product-card__content m:text-left">
          <div class="m-product-card__info">
            <h3 class="m-product-card__title">
              <span class="m-product-card__name">${escapeHtml(displayTitle)}</span>
            </h3>
            <div class="m-product-card__price">
              <div class="m-price">
                <div class="m-price__regular">
                  <span class="m-price-item m-price-item--regular">${escapeHtml(formatPrice(product))}</span>
                </div>
              </div>
            </div>
            <div class="ef-rating customerReviews">
              <span class="ef-stars">
                <i class="star full">★</i><i class="star full">★</i><i class="star full">★</i><i class="star full">★</i><i class="star empty">★</i>
              </span>
              <span class="ef-score">4.2 (${reviewCount} reviews)</span>
            </div>
            <div class="product-icons">
              <div class="icon-text">${trustIcon}<span>${escapeHtml(t('verifiedFitment'))}</span></div>
              <div class="icon-text">${supportIcon}<span>${escapeHtml(t('support'))}</span></div>
            </div>
          </div>
        </div>
      </a>
    `;
  }

  function renderEmpty(state) {
    return `
      <div class="ef-fitment-empty">
        <h2>${escapeHtml(t('noCompatible'))}</h2>
        <p>${escapeHtml(stateQueryText(state))}</p>
      </div>
    `;
  }

  function renderSnizeCard(product, state) {
    const displayTitle = productDisplayTitle(product);
    const productBadge = product.productBadge || (product.stockType === 'eu-stock' ? 'EU stock' : product.stockType === 'made-to-order' ? 'Precision Build' : '');
    const badge = productBadge ? `<div class="EuStockBadge">${escapeHtml(productBadge)}</div>` : '';
    const image = product.image
      ? `<span class="snize-thumbnail"><img src="${escapeHtml(product.image)}" class="snize-item-image " alt="${escapeHtml(displayTitle)}" border="0" loading="lazy"></span>`
      : '<span class="snize-thumbnail"></span>';
    const widthStyle = state.view === 'list' ? '' : ' style="width: 31.3%;"';
    const stockClass = product.stockType ? ` snize-product-tag-${classKey(product.stockType)}` : '';
    const typeClass = product.productType ? ` snize-product-tag-${classKey(product.productType)}` : '';
    const vendorClass = product.vendor ? ` snize-product-vendor-${classKey(product.vendor)}` : '';
    const ctaLabel = t('viewProduct');

    return `
      <li class="snize-product snize-product-in-stock${vendorClass}${stockClass}${typeClass} snize-show-cta-on-hover snize-layout-default" data-original-product-id="${escapeHtml(product.id)}" id="snize-product-${escapeHtml(product.id)}"${widthStyle}>
        <a href="${escapeHtml(product.url)}" aria-label="${escapeHtml(displayTitle)}" class="snize-view-link" data-no-instant="true" draggable="false">
          <div class="snize-item clearfix ">
            <div class="snize-thumbnail-wrapper">${badge}${image}</div>
            <span class="snize-overhidden">
              <span class="snize-title" style="max-height: 2.8em; -webkit-line-clamp: 2;">${escapeHtml(displayTitle)}</span>
              <div class="snize-price-list snize-compare-price-right">
                <span class="snize-price money ">${escapeHtml(formatPrice(product))}<span class="snize-highlight-saving-text"></span></span>
                <span class="ef-fitment-card-price-note">${product.stockType === 'eu-stock' ? escapeHtml(t('inStockPrice')) : escapeHtml(t('customBuiltPrice'))}</span>
              </div>
              <div class="ef-fitment-card-rating" aria-label="${escapeHtml(t('storeRatingAria'))}">
                <span class="ef-fitment-card-stars" aria-hidden="true">★★★★☆</span>
                <span class="ef-fitment-card-rating-count">${escapeHtml(t('storeRating'))}</span>
              </div>
              <div class="ef-fitment-card-cta">${escapeHtml(ctaLabel)}</div>
            </span>
          </div>
        </a>
      </li>
    `;
  }

  function renderSnizeEmpty(state) {
    return `
      <div class="snize-no-products-found">
        <div class="snize-no-products-found-text">${escapeHtml(t('noCompatibleFor'))} ${escapeHtml(stateQueryText(state))}</div>
      </div>
    `;
  }

  function ensureSearchaniseShell(snizeEl) {
    let wrapper = snizeEl.querySelector('.snize-horizontal-wrapper');
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'snize-horizontal-wrapper';
      const panel = snizeEl.querySelector('.snize-main-panel');
      if (panel && panel.nextSibling) panel.parentNode.insertBefore(wrapper, panel.nextSibling);
      else snizeEl.appendChild(wrapper);
    }

    let left = wrapper.querySelector('.snize-horizontal-left');
    if (!left) {
      left = document.createElement('div');
      left.className = 'snize-horizontal-left';
      wrapper.insertBefore(left, wrapper.firstChild);
    }

    let right = wrapper.querySelector('.snize-horizontal-right');
    if (!right) {
      right = document.createElement('div');
      right.className = 'snize-horizontal-right';
      wrapper.appendChild(right);
    }

    let header = left.querySelector('.snize-header');
    if (!header) {
      header = document.createElement('div');
      header.className = 'snize-header';
      left.appendChild(header);
    }

    let headerText = header.querySelector('.snize-search-results-header');
    if (!headerText) {
      headerText = document.createElement('div');
      headerText.className = 'snize-search-results-header';
      header.appendChild(headerText);
    }

    let content = snizeEl.querySelector('.snize-search-results-main-content');
    if (!content) {
      content = document.createElement('div');
      content.className = 'snize-search-results-main-content';
      snizeEl.appendChild(content);
    }

    return { right, headerText, content };
  }

  function updateTabs(snizeEl, count) {
    let panel = snizeEl.querySelector(':scope > .snize-main-panel');
    if (!panel) {
      panel = document.createElement('div');
      panel.className = 'snize-main-panel';
      snizeEl.insertBefore(panel, snizeEl.firstChild);
    }

    let controls = panel.querySelector('.snize-main-panel-controls');
    if (!controls) {
      controls = document.createElement('div');
      controls.className = 'snize-main-panel-controls';
      controls.setAttribute('role', 'tablist');
      panel.insertBefore(controls, panel.firstChild);
    }

    let list = controls.querySelector('ul');
    if (!list) {
      list = document.createElement('ul');
      list.setAttribute('role', 'presentation');
      controls.appendChild(list);
    }

    let productTab = controls.querySelector('.snize-main-panel-controls-products');
    if (!productTab) {
      const item = document.createElement('li');
      item.innerHTML = `<a href="#" role="tab" aria-label="${escapeHtml(t('viewProductsTab'))}" class="snize-main-panel-controls-products" data-no-instant="true">${escapeHtml(t('products'))}<span class="snize-products-tab-total"></span></a>`;
      list.insertBefore(item, list.firstChild);
      productTab = item.querySelector('.snize-main-panel-controls-products');
    }

    if (productTab) {
      productTab.classList.add('active');
      productTab.setAttribute('aria-current', 'page');
      productTab.setAttribute('aria-selected', 'true');
      const total = productTab.querySelector('.snize-products-tab-total');
      if (total) total.textContent = String(count);
    }

    snizeEl.querySelectorAll('.snize-main-panel-controls-categories, .snize-main-panel-controls-pages').forEach((tab) => {
      tab.classList.remove('active');
      tab.removeAttribute('aria-current');
      tab.setAttribute('aria-selected', 'false');
    });
  }

  function normalizeViewModeControls(snizeEl, state) {
    snizeEl.querySelectorAll('.snize-main-panel-view-mode').forEach((viewMode) => {
      if (!viewMode.closest('.snize-horizontal-right')) viewMode.remove();
    });

    const container = snizeEl.querySelector('.snize-horizontal-right .snize-main-panel-view-mode');
    if (!container) return;

    let hasGrid = false;
    let hasList = false;
    container.querySelectorAll('.snize-view-mode-icon').forEach((icon) => {
      const isGrid = icon.classList.contains('snize-grid-mode-icon');
      const isList = icon.classList.contains('snize-list-mode-icon');

      if (isGrid && !hasGrid) {
        hasGrid = true;
        icon.classList.toggle('active', state.view !== 'list');
        icon.setAttribute('aria-pressed', state.view !== 'list' ? 'true' : 'false');
        return;
      }

      if (isList && !hasList) {
        hasList = true;
        icon.classList.toggle('active', state.view === 'list');
        icon.setAttribute('aria-pressed', state.view === 'list' ? 'true' : 'false');
        return;
      }

      icon.remove();
    });
  }

  function watchViewModeControls(snizeEl, state) {
    if (snizeEl.dataset.fitmentViewModeWatch === 'true') return;

    snizeEl.dataset.fitmentViewModeWatch = 'true';
    const observer = new MutationObserver(() => {
      normalizeViewModeControls(snizeEl, getStructuredParams() || state);
    });
    observer.observe(snizeEl, { childList: true, subtree: true });
  }

  function getRenderedPriceBounds(range) {
    const lower = Number(range?.dataset.priceLower || 0);
    const upper = Number(range?.dataset.priceUpper || lower);
    return {
      lower: Number.isFinite(lower) ? lower : 0,
      upper: Number.isFinite(upper) ? upper : 0
    };
  }

  function getRenderedPriceSelection(range) {
    const { lower, upper } = getRenderedPriceBounds(range);
    const minInput = range?.querySelector('[data-fitment-price-min]');
    const maxInput = range?.querySelector('[data-fitment-price-max]');
    const rawMin = normalizePriceParam(minInput?.value);
    const rawMax = normalizePriceParam(maxInput?.value);
    const selectedMin = clampPrice(hasPriceValue(rawMin) ? Number(rawMin) : lower, lower, upper);
    const selectedMax = clampPrice(hasPriceValue(rawMax) ? Number(rawMax) : upper, lower, upper);
    return {
      lower,
      upper,
      min: Math.min(selectedMin, selectedMax),
      max: Math.max(selectedMin, selectedMax)
    };
  }

  function setRenderedPriceSelection(range, min, max) {
    if (!range) return;
    const { lower, upper } = getRenderedPriceBounds(range);
    const selectedMin = Math.min(clampPrice(min, lower, upper), clampPrice(max, lower, upper));
    const selectedMax = Math.max(clampPrice(min, lower, upper), clampPrice(max, lower, upper));
    const minInput = range.querySelector('[data-fitment-price-min]');
    const maxInput = range.querySelector('[data-fitment-price-max]');
    const hiddenInput = range.querySelector('.snize-range-slider');
    if (minInput) minInput.value = Math.round(selectedMin);
    if (maxInput) maxInput.value = Math.round(selectedMax);
    if (hiddenInput) hiddenInput.value = `${Math.round(selectedMin)},${Math.round(selectedMax)}`;
    updateRenderedPriceSlider(range, selectedMin, selectedMax);
  }

  function updateRenderedPriceSlider(range, min, max) {
    const slider = range?.querySelector('[data-fitment-price-slider]');
    const track = range?.querySelector('[data-fitment-price-track]');
    if (!slider || !track) return;

    const { lower, upper } = getRenderedPriceBounds(range);
    const lowPercent = pricePercent(min, lower, upper) * 100;
    const highPercent = pricePercent(max, lower, upper) * 100;
    const selectedLeft = Math.min(lowPercent, highPercent);
    const selectedWidth = Math.max(0, Math.abs(highPercent - lowPercent));

    const selectedBar = range.querySelector('.selected-bar');
    const lowHandle = range.querySelector('[data-fitment-price-handle="min"]');
    const highHandle = range.querySelector('[data-fitment-price-handle="max"]');
    if (selectedBar) {
      selectedBar.style.left = `${selectedLeft}%`;
      selectedBar.style.width = `${selectedWidth}%`;
    }
    if (lowHandle) lowHandle.style.left = `${lowPercent}%`;
    if (highHandle) highHandle.style.left = `${highPercent}%`;
  }

  function priceFromPointer(range, clientX) {
    const track = range?.querySelector('[data-fitment-price-track]');
    const rect = track?.getBoundingClientRect();
    if (!rect || rect.width <= 0) return null;
    const { lower, upper } = getRenderedPriceBounds(range);
    const percent = Math.min(1, Math.max(0, (clientX - rect.left) / rect.width));
    return Math.round(lower + ((upper - lower) * percent));
  }

  function bindRenderedControls(snizeEl, state, allProducts, page) {
    snizeEl.querySelectorAll('[data-fitment-param]').forEach((control) => {
      control.addEventListener('change', function () {
        const key = this.dataset.fitmentParam;
        const currentState = getStructuredParams();
        const group = this.closest('.snize-product-filters-block') || snizeEl;
        const values = [...group.querySelectorAll('[data-fitment-param]')]
          .filter((input) => input.dataset.fitmentParam === key && input.checked)
          .map((input) => input.value);
        const updates = { [key]: values, fitment_page: '' };
        if (key === 'fitment_make') updates.fitment_model = '';
        if (shouldRefreshStructuredQuery(currentState)) updates.q = '';
        updateUrl(updates);
        render(snizeEl, Object.assign({}, getStructuredParams(), { page: 1 }), allProducts);
      });
    });

    const priceRange = snizeEl.querySelector('[data-fitment-price-range]');
    const updatePricePreview = () => {
      if (!priceRange) return;
      const selection = getRenderedPriceSelection(priceRange);
      setRenderedPriceSelection(priceRange, selection.min, selection.max);
    };

    const applyPriceFilter = () => {
      if (!priceRange) return;
      const selection = getRenderedPriceSelection(priceRange);
      setRenderedPriceSelection(priceRange, selection.min, selection.max);
      const updates = {
        fitment_price_min: selection.min > selection.lower ? Math.round(selection.min) : '',
        fitment_price_max: selection.max < selection.upper ? Math.round(selection.max) : '',
        fitment_page: ''
      };
      if (shouldRefreshStructuredQuery(getStructuredParams())) updates.q = '';

      updateUrl(updates);
      render(snizeEl, Object.assign({}, getStructuredParams(), { page: 1 }), allProducts);
    };

    snizeEl.querySelectorAll('[data-fitment-price-min], [data-fitment-price-max]').forEach((input) => {
      input.addEventListener('input', updatePricePreview);
      input.addEventListener('change', applyPriceFilter);
      input.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        applyPriceFilter();
      });
    });

    if (priceRange) {
      updatePricePreview();
      priceRange.querySelectorAll('[data-fitment-price-handle]').forEach((handle) => {
        handle.addEventListener('pointerdown', function (event) {
          event.preventDefault();
          event.stopPropagation();
          const activeHandle = this.dataset.fitmentPriceHandle;
          const move = (moveEvent) => {
            const value = priceFromPointer(priceRange, moveEvent.clientX);
            if (value === null) return;
            const selection = getRenderedPriceSelection(priceRange);
            if (activeHandle === 'min') setRenderedPriceSelection(priceRange, value, selection.max);
            else setRenderedPriceSelection(priceRange, selection.min, value);
          };
          const up = () => {
            document.removeEventListener('pointermove', move);
            document.removeEventListener('pointerup', up);
            applyPriceFilter();
          };
          document.addEventListener('pointermove', move);
          document.addEventListener('pointerup', up, { once: true });
        });
      });

      priceRange.querySelector('[data-fitment-price-track]')?.addEventListener('click', function (event) {
        if (event.target.closest('[data-fitment-price-handle]')) return;
        const value = priceFromPointer(priceRange, event.clientX);
        if (value === null) return;
        const selection = getRenderedPriceSelection(priceRange);
        const target = Math.abs(value - selection.min) <= Math.abs(value - selection.max) ? 'min' : 'max';
        if (target === 'min') setRenderedPriceSelection(priceRange, value, selection.max);
        else setRenderedPriceSelection(priceRange, selection.min, value);
        applyPriceFilter();
      });
    }

    snizeEl.querySelectorAll('[data-fitment-filter-toggle]').forEach((title) => {
      title.addEventListener('click', function () {
        const list = this.parentElement?.querySelector('.snize-product-filters-list');
        const open = !this.classList.contains('open');
        this.classList.toggle('open', open);
        this.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (list) list.style.display = open ? '' : 'none';
      });
      title.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        this.click();
      });
    });

    snizeEl.querySelectorAll('.snize-grid-mode-icon, .snize-list-mode-icon').forEach((button) => {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        const view = this.classList.contains('snize-list-mode-icon') ? 'list' : 'grid';
        try {
          window.localStorage?.setItem('ef_fitment_view', view);
        } catch (error) {}
        updateUrl({ fitment_view: view, fitment_page: '' });
        render(snizeEl, Object.assign({}, getStructuredParams(), { view, page: 1 }), allProducts);
      }, true);
    });

    const dropdownButton = snizeEl.querySelector('.snize-main-panel-dropdown-button');
    const dropdownList = snizeEl.querySelector('#snize-sorting-options-list');
    if (dropdownButton && dropdownList) {
      const openSortDropdown = function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        dropdownList.style.display = 'block';
        dropdownButton.setAttribute('aria-expanded', 'true');
      };
      dropdownButton.addEventListener('pointerdown', openSortDropdown, true);
      dropdownButton.addEventListener('mousedown', openSortDropdown, true);
      dropdownButton.addEventListener('click', openSortDropdown, true);
    }

    snizeEl.querySelectorAll('#snize-sorting-options-list a').forEach((option) => {
      option.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        const sort = sortFromSnizeClass(this.className) || 'relevance';
        updateUrl({ fitment_sort: sort === 'relevance' ? '' : sort, fitment_page: '' });
        render(snizeEl, Object.assign({}, getStructuredParams(), { sort, page: 1 }), allProducts);
      }, true);
    });

    snizeEl.querySelectorAll('[data-fitment-remove-filter]').forEach((button) => {
      button.addEventListener('click', function () {
        const key = this.dataset.fitmentRemoveFilter;
        const value = normalizeText(this.dataset.fitmentRemoveValue);
        const current = getStructuredParams() || state;
        const updates = { fitment_page: '' };
        if (key === 'fitment_price') {
          updates.fitment_price_min = '';
          updates.fitment_price_max = '';
        } else {
          const values = getParamValues(new URLSearchParams(window.location.search), key)
            .filter((item) => normalizeText(item) !== value);
          updates[key] = values;
          if (key === 'fitment_make') updates.fitment_model = '';
        }
        if (shouldRefreshStructuredQuery(current)) updates.q = '';
        updateUrl(updates);
        render(snizeEl, Object.assign({}, getStructuredParams(), { page: 1 }), allProducts);
      });
    });

    const clearFilters = snizeEl.querySelector('[data-fitment-clear-filters]');
    if (clearFilters) {
      clearFilters.addEventListener('click', function () {
        const updates = {
          fitment_make: '',
          fitment_model: '',
          fitment_year: '',
          fitment_stock: '',
          fitment_product_type: '',
          fitment_price_min: '',
          fitment_price_max: '',
          fitment_page: '',
          q: ''
        };
        updateUrl(updates);
        render(snizeEl, Object.assign({}, getStructuredParams(), { page: 1 }), allProducts);
      });
    }

    const loadMore = snizeEl.querySelector('[data-fitment-load-more]');
    if (loadMore) {
      loadMore.addEventListener('click', function () {
        updateUrl({ fitment_page: String(page + 1) });
        render(snizeEl, Object.assign({}, state, { page: page + 1 }), allProducts);
      });
    }

    const productTab = snizeEl.querySelector('.snize-main-panel-controls-products');
    if (productTab) {
      productTab.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        render(snizeEl, getStructuredParams() || state, allProducts);
      }, true);
    }

    const mobileFilters = snizeEl.querySelector('[data-fitment-mobile-filters]');
    const mobileFiltersClose = snizeEl.querySelector('[data-fitment-mobile-filters-close]');
    const filtersSidebar = snizeEl.querySelector(':scope > .snize-filters-sidebar');
    const closeMobileFilters = () => {
      document.body.classList.remove('ef-fitment-mobile-filters-open');
      if (mobileFilters) mobileFilters.setAttribute('aria-expanded', 'false');
      if (filtersSidebar) filtersSidebar.setAttribute('aria-hidden', 'true');
    };
    const openMobileFilters = (event) => {
      event.preventDefault();
      event.stopPropagation();
      document.body.classList.add('ef-fitment-mobile-filters-open');
      mobileFilters.setAttribute('aria-expanded', 'true');
      if (filtersSidebar) filtersSidebar.setAttribute('aria-hidden', 'false');
    };

    if (mobileFilters) mobileFilters.addEventListener('click', openMobileFilters);
    if (mobileFiltersClose) mobileFiltersClose.addEventListener('click', closeMobileFilters);

    updateActiveFilterOverflow(snizeEl);
    requestAnimationFrame(() => updateActiveFilterOverflow(snizeEl));
    if (typeof window !== 'undefined') {
      window.requestAnimationFrame(() => updateActiveFilterOverflow(snizeEl));
    }
    if (typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(() => updateActiveFilterOverflow(snizeEl));
      const activeFilters = snizeEl.querySelector('.ef-fitment-active-filters');
      if (activeFilters) observer.observe(activeFilters);
      snizeEl._efFitmentOverflowObserver = observer;
    }
  }

  function render(snizeEl, state, allProducts) {
    if (!state) return;
    state = normalizeStateSelections(state);
    state.freeTextTerms = freeTextTerms(state);

    const selectedMakes = selectedValues(state, 'makeValues', 'make');
    const selectedModels = selectedValues(state, 'modelValues', 'model');
    const selectedYears = selectedValues(state, 'yearValues', 'year');
    const selectedStock = selectedValues(state, 'stockValues', 'stock');
    const selectedTypes = selectedValues(state, 'productTypeValues', 'productType');
    ensureSearchQuery(state);

    const makeProducts = selectedMakes.length ? allProducts.filter((product) => selectedMakes.includes(product.make)) : allProducts;
    const modelProducts = selectedModels.length ? makeProducts.filter((product) => productModelMatches(product, state)) : makeProducts;
    const makeFilters = getAvailableFilters(allProducts.filter((product) => matchesYear(product, selectedYears) && matchesStock(product, selectedStock) && matchesProductType(product, selectedTypes) && matchesPrice(product, state.priceMin, state.priceMax)));
    const modelFilters = getAvailableFilters(makeProducts.filter((product) => matchesYear(product, selectedYears) && matchesStock(product, selectedStock) && matchesProductType(product, selectedTypes) && matchesPrice(product, state.priceMin, state.priceMax)));
    const stockFilters = getAvailableFilters(modelProducts.filter((product) => matchesYear(product, selectedYears) && matchesProductType(product, selectedTypes) && matchesPrice(product, state.priceMin, state.priceMax)));
    const typeFilters = getAvailableFilters(modelProducts.filter((product) => matchesYear(product, selectedYears) && matchesStock(product, selectedStock) && matchesPrice(product, state.priceMin, state.priceMax)));
    const yearFilters = getAvailableFilters(modelProducts.filter((product) => matchesStock(product, selectedStock) && matchesProductType(product, selectedTypes) && matchesPrice(product, state.priceMin, state.priceMax)));
    const priceBounds = getPriceBounds(modelProducts.filter((product) => matchesYear(product, selectedYears) && matchesStock(product, selectedStock) && matchesProductType(product, selectedTypes)));
    // EF SEARCH FIX 2026-08-01 START (Null-Treffer-Fallback auf das reine Fitment-Ergebnis)
    let filtered = sortProducts(allProducts.filter((product) => productMatches(product, state)), state.sort);
    if (!filtered.length && Array.isArray(state.freeTextTerms) && state.freeTextTerms.length) {
      state.efDroppedWords = efFreeTextWords(state);
      state.efTextFallback = true;
      state.freeTextTerms = [];
      filtered = sortProducts(allProducts.filter((product) => productMatches(product, state)), state.sort);
    }
    // EF SEARCH FIX 2026-08-01 END
    const maxPage = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
    const page = Math.min(state.page, maxPage);
    const visible = filtered.slice(0, page * PAGE_SIZE);

    const makeOptions = withSelectedOptions([...makeFilters.makes.entries()].map(([value, count]) => ({ value, count, label: value })), selectedMakes).sort(optionSort);
    const modelOptions = withSelectedOptions([...modelFilters.models.entries()].map(([value, count]) => ({ value, count, label: value })), selectedModels).sort(optionSort);
    const stockOptions = withSelectedOptions([...stockFilters.stock.entries()].map(([value, count]) => ({ value, count, label: stockLabel(value) })), selectedStock, stockLabel).sort(optionSort);
    const typeOptions = withSelectedOptions([...typeFilters.types.entries()].map(([value, count]) => ({ value, count, label: value })), selectedTypes, canonicalProductType).sort(optionSort);
    const yearOptions = withSelectedOptions([...yearFilters.years.entries()].map(([value, count]) => ({ value, count, label: value })), selectedYears).sort(optionSort);

    snizeEl.removeAttribute('hidden');
    snizeEl.classList.add('ef-fitment-snize');
    snizeEl.querySelectorAll(':scope > [data-ef-native-sidebar], :scope > [data-ef-native-grid]').forEach((node) => node.remove());
    snizeEl.querySelectorAll(':scope > .snize-header').forEach((header) => header.remove());
    updateTabs(snizeEl, filtered.length);

    const { right, headerText, content } = ensureSearchaniseShell(snizeEl);
    right.innerHTML = renderHorizontalRight(state);
    normalizeViewModeControls(snizeEl, state);
    watchViewModeControls(snizeEl, state);
    const queryLink = `<a href="#" class="snize-no-products-found-link" data-no-instant="true">${escapeHtml(stateQueryText(state))}</a>`;
    headerText.innerHTML = template('showingResults', { count: escapeHtml(filtered.length), query: queryLink });
    headerText.insertAdjacentHTML('beforeend', renderActiveFilters(state));
    // EF SEARCH FIX 2026-08-01 START (dezenter Hinweis bei Null-Treffer-Fallback)
    if (state.efTextFallback) {
      const efIsDe = (document.documentElement.lang || '').toLowerCase().indexOf('de') === 0;
      const efWords = escapeHtml((state.efDroppedWords || []).join(' '));
      const efScope = escapeHtml(stateQueryText(state));
      const efNote = efIsDe
        ? 'Keine Treffer f&uuml;r &bdquo;' + efWords + '&ldquo; &ndash; es werden alle Ergebnisse f&uuml;r ' + efScope + ' gezeigt.'
        : 'No matches for &quot;' + efWords + '&quot; &ndash; showing all results for ' + efScope + '.';
      headerText.insertAdjacentHTML('beforeend', '<div class="ef-search-fix-note" style="margin-top:6px;font-size:13px;opacity:.75">' + efNote + '</div>');
    }
    // EF SEARCH FIX 2026-08-01 END
    document.title = template('searchTitle', { count: filtered.length, query: stateQueryText(state) });

    snizeEl.querySelectorAll(':scope > .snize-filters-sidebar').forEach((sidebar) => sidebar.remove());
    const sidebar = document.createElement('div');
    sidebar.className = 'snize-filters-sidebar snize-product-filters';
    sidebar.innerHTML = `
      <div class="ef-fitment-mobile-filter-header">
        <span>${escapeHtml(t('filters'))}</span>
        <button type="button" data-fitment-mobile-filters-close aria-label="${escapeHtml(t('closeFilters'))}">${escapeHtml(t('close'))}</button>
      </div>
      ${renderFilterGroup(t('availability'), 'stock_type', 'fitment_stock', selectedStock, stockOptions)}
      ${renderPriceFilter(state, priceBounds)}
      ${renderFilterGroup(t('brand'), 'make', 'fitment_make', selectedMakes, makeOptions)}
      ${renderFilterGroup(t('model'), 'model', 'fitment_model', selectedModels, modelOptions)}
      ${renderFilterGroup(t('year'), 'year', 'fitment_year', selectedYears, yearOptions)}
      ${renderFilterGroup(t('productType'), 'product_type', 'fitment_product_type', selectedTypes, typeOptions)}
    `;
    snizeEl.insertBefore(sidebar, content);

    const resultsModeId = state.view === 'list' ? 'snize-search-results-list-mode' : 'snize-search-results-grid-mode';
    const resultsModeClass = state.view === 'list' ? '' : 'snize-three-columns';
    snizeEl.querySelectorAll(':scope > .snize-pagination').forEach((pagination) => pagination.remove());
    content.innerHTML = visible.length
      ? `
        <div id="${resultsModeId}" class="${resultsModeClass}">
          <ul class="snize-search-results-content clearfix">
            ${visible.map((product) => renderSnizeCard(product, state)).join('')}
          </ul>
        </div>
      `
      : renderSnizeEmpty(state);

    if (visible.length < filtered.length) {
      const pagination = document.createElement('div');
      pagination.className = 'snize-pagination';
      pagination.innerHTML = '<button class="ef-fitment-load-more" type="button" data-fitment-load-more>Load more products</button>';
      snizeEl.insertBefore(pagination, content.nextSibling);
    }

    bindRenderedControls(snizeEl, state, allProducts, page);
    setFitmentMode(false);
  }

  async function renderResultsPage() {
    if (!isSearchPath(window.location.pathname)) return false;
    let state = getStructuredParams();
    const params = new URLSearchParams(window.location.search);
    if (!state && params.get('q')) {
      const structuredUrl = await resolveUrl(params.get('q'), params.get('rb_tags') === 'EU stock' ? { stock: 'eu-stock' } : {});
      if (structuredUrl) {
        window.history.replaceState({}, '', structuredUrl);
        state = getStructuredParams();
      } else {
        state = getTextSearchState(params.get('q'));
      }
    }
    if (!state) return false;

    await getManifest();
    state = await enrichStructuredStateFromQuery(state);
    setFitmentMode(true);
    state = normalizeStateSelections(state);
    const hasStructuredSelection = selectedValues(state, 'makeValues', 'make').length ||
      selectedValues(state, 'modelValues', 'model').length ||
      selectedValues(state, 'yearValues', 'year').length ||
      selectedValues(state, 'stockValues', 'stock').length ||
      selectedValues(state, 'productTypeValues', 'productType').length ||
      hasPriceValue(state.priceMin) ||
      hasPriceValue(state.priceMax);
    const hasTextSelection = freeTextTerms(state).length > 0;
    if (!hasStructuredSelection && !hasTextSelection) {
      clearFitmentMode();
      return false;
    }
    const products = await getAllProducts();

    ensureSearchQuery(state);

    const searchanise = document.getElementById('snize_results') || await waitForElement('#snize_results', 7000);
    if (!searchanise) {
      clearFitmentMode();
      return false;
    }

    const oldContainer = document.getElementById('ef-fitment-results');
    if (oldContainer) oldContainer.remove();
    render(searchanise, state, products);
    return true;
  }

  root.resolveUrl = resolveUrl;
  root.renderResultsPage = renderResultsPage;
  root.getManifest = getManifest;
  root.getMakeIndex = getMakeIndex;
  root.matchKey = matchKey;
  root.parseFitmentQuery = async function (query) {
    return parseFitmentQuery(query, await getManifest());
  };
  window.EFFitmentSearch = root;

  if (isSearchPath(window.location.pathname) && getStructuredParams()) {
    setFitmentMode(true);
  }

  document.addEventListener('DOMContentLoaded', function () {
    renderResultsPage().catch((error) => console.error('[EFFitmentSearch]', error));
  });
})();
